<template>
  
      <edit-profile-form> </edit-profile-form>
  
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
export default {
  components: {
    EditProfileForm,
  },
};
</script>
<style></style>
